"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSegmentEventViewed = exports.SegmentEventViewed = void 0;
const react_1 = __importStar(require("react"));
const react_waypoint_1 = require("react-waypoint");
const logging_1 = require("@nerdwallet/logging");
const segment_event_1 = require("../../segment-event");
const segment_page_view_1 = require("../segment-page-view");
const SegmentEventViewedContext = (0, react_1.createContext)(null);
const segmentLogger = (0, logging_1.getLogger)('BAIN-SegmentEventViewed');
exports.SegmentEventViewed = (0, react_1.forwardRef)((_a, ref) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    const { pageViewReady } = (0, segment_page_view_1.useSegmentPageView)();
    const [viewed, setViewed] = (0, react_1.useState)(false);
    const [viewedPayload, setViewedPayload] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        if (pageViewReady && viewed) {
            (0, segment_event_1.segmentEventViewed)(props.eventName, props === null || props === void 0 ? void 0 : props.eventPayload);
            setViewedPayload((props === null || props === void 0 ? void 0 : props.eventPayload) || {});
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageViewReady, viewed]);
    const context = {
        viewedPayload,
    };
    const child = typeof children === 'function' ? children(context) : children;
    if (!child) {
        const errMsg = 'Missing Child Component';
        segmentLogger.error(errMsg);
        throw new Error(errMsg);
    }
    return (react_1.default.createElement(SegmentEventViewedContext.Provider, { value: context },
        react_1.default.createElement(react_waypoint_1.Waypoint, { scrollableAncestor: "window", onEnter: () => {
                setViewed(true);
            } }, (0, react_1.cloneElement)(child, { ref }))));
});
const useSegmentEventViewed = () => {
    const context = (0, react_1.useContext)(SegmentEventViewedContext);
    if (!context) {
        const errMsg = 'useSegmentEventViewed must be used within SegmentEventViewed';
        segmentLogger.error(errMsg);
        throw new Error(errMsg);
    }
    return context;
};
exports.useSegmentEventViewed = useSegmentEventViewed;
